import React from "react";
import PropTypes from "prop-types";
import { TriyoForm } from "../../../../../../components/TriyoForm";
import { reminderHelpers } from "./reminder-helpers";
import SelectReminderType from "./select-reminder-type";
import OneTimeReminders from "./one-time-reminders";
import RecurringReminders from "./recurring-reminders";
import DueDateReminders from "./due-date-reminders";
import CustomReminders from "./custom-reminders";
import "./reminders.scss";

const Reminders = ({
  taskReminder,
  setTaskReminder,
  setCustomReminders,
  customReminders,
}) => {
  return (
    <div className="task-accordion-container task-reminders task-type-reminder">
      <div className="heading">
        <div className="heading-description">
          <h4 className="heading-name">Set Task Reminders</h4>
        </div>
        <TriyoForm.Toggle
          id="custom-switch"
          checked={taskReminder?.exist}
          onChange={(e) => {
            reminderHelpers.updateExist(setTaskReminder, e?.target?.checked);
          }}
        />
      </div>
      <div>
        <SelectReminderType
          taskReminder={taskReminder}
          setTaskReminder={setTaskReminder}
        />
        <div className="reminderContainer">
          {taskReminder?.reminder?.id == 0 && (
            <DueDateReminders
              taskReminder={taskReminder}
              setTaskReminder={setTaskReminder}
            />
          )}
          {taskReminder?.reminder?.id == 1 && (
            <RecurringReminders
              taskReminder={taskReminder}
              setTaskReminder={setTaskReminder}
            />
          )}
          {(taskReminder?.reminder?.id == 2 ||
            taskReminder?.reminder?.id == 3) && (
            <OneTimeReminders
              taskReminder={taskReminder}
              setTaskReminder={setTaskReminder}
            />
          )}
          {taskReminder?.reminder?.id == 4 && (
            <CustomReminders
              taskReminder={taskReminder}
              setTaskReminder={setTaskReminder}
              customReminders={customReminders}
              setCustomReminders={setCustomReminders}
            />
          )}
        </div>
      </div>
    </div>
  );
};

Reminders.propTypes = {
  taskReminder: PropTypes.shape({
    exist: PropTypes.bool,
    reminder: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  setTaskReminder: PropTypes.func.isRequired,
  customReminders: PropTypes.arrayOf(PropTypes.shape({})),
  setCustomReminders: PropTypes.func.isRequired,
};

export default Reminders;
